export default "__VITE_ASSET__CfQNvhBb__"